export const GenericButtonStyleMd = 'md:text-white'
export const GenericButtonStyleSm = 'sm:text-white'
export const GenericButtonStyleLg = 'lg:text-white'
export const GenericButtonStyleXl = 'lg:text-white'

export const genericFontStyle = `md:${GenericButtonStyleMd} sm:${GenericButtonStyleSm} lg:${GenericButtonStyleLg} xl:${GenericButtonStyleXl} text-sm text-white`;

export const navigationButtonStyle = `${genericFontStyle} w-30 sm:m-3 md:m-6 lg:m-8 xl:m-10 font-regular`;

export const logoImageStyle = "w-6 h-8 ml-20";